import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export default api;

// Brand assets — served from /public
export const LOGO_URL = "/logo.svg";
export const ICON_URL = "/icon.svg";
